class loadingButton extends HTMLElement {
  constructor() {
    super()
    this.url = '';
    this.automaticLoading = this.getAttribute('automatic-loading')
    this.loadButton =  this.querySelector('button');
    this.productContainer =  document.querySelector('#product-grid');
    this.vanillaPagination =  document.querySelector('.pagination');
    this.previous = this.dataset.previous;
    this.paginationWrapper = document.querySelector('.pagination-wrapper');
    this.loadButton.addEventListener(
      'click',
      this.loadMore.bind(this)
    );

    // loading observer
    let options = {
      root: null,
      rootMargin: "500px",
      threshold: 0.25
    };
    this.observer = new IntersectionObserver(this.handleIntersection, options);
  }

  connectedCallback() {
    if (this.automaticLoading === 'infinite-scroll' ) {
      this.observer.observe(this.loadButton);
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        entry.target.closest('loading-button').loadMore();
      }
    });
  }

  loadMore() {
    let element
    if(this.previous === 'true') {
      element = this.querySelector('.pagination__item--previous');
    } else {
      element = this.vanillaPagination.querySelector('.pagination__item--next');
    }
    if(!element) return;
    this.url = element.href;
    this.loadButton.classList.add('loading');
    this.loadButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    this.fetchItems(this.url);
    const pageNumber = parseInt((element.dataset.page.split('page=')[1]).split('&')[0]);

    if(this.previous === 'true') {
      const newPageNumber = pageNumber - 1
      element.dataset.page = element.dataset.page.replace(pageNumber, newPageNumber)
      element.href = element.href.replace(pageNumber, newPageNumber)
      if(newPageNumber === 0) this.style.display = 'none'
    } else {
      const newPageNumber = pageNumber + 1
      element.dataset.page = element.dataset.page.replace(pageNumber, newPageNumber)
      element.href = element.href.replace(pageNumber, newPageNumber)
      if(newPageNumber === this.dataset.maxPages) this.style.display = 'none'
    }

    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('page')) {
      urlParams.set('page', pageNumber);
    } else {
      urlParams.append('page', pageNumber);
    }

    // Set page URL in history
    history.replaceState({ page: pageNumber }, `Page ${pageNumber}`, `?${urlParams.toString()}`);
  }

  fetchItems(url) {
    let sectionID = this.closest('.shopify-section.section').getAttribute('id').replace('shopify-section-', '');
    fetch(url + '&section_id=' + sectionID)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderProductGrid(html);
        this.renderNewNavigation(html);
        this.loadingButtonChecker();
      });
  }

  renderProductGrid(html) {
    let newPage = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
    newPage.querySelectorAll('script').forEach((element) => {
      element.parentNode.removeChild(element);
    });
    let templateElement = document.createElement('template');
    templateElement.innerHTML = newPage.innerHTML;

    if(this.previous === 'true') {
      this.productContainer.prepend(templateElement.content);
    } else {
      this.productContainer.append(templateElement.content);
    }
  }
  renderNewNavigation(html) {
    this.vanillaPagination.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.pagination').innerHTML;
  }

  loadingButtonChecker() {
    this.loadButton.classList.remove('loading');
    this.loadButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
    if (document.querySelectorAll('.pagination-wrapper a.pagination__item--next').length === 0) {
      this.loadButton.classList.add('hidden')
      this.paginationWrapper.classList.add('hidden');
    }
  }
}

customElements.define('loading-button', loadingButton)